import React from 'react';
import type {
  DriverSubCategory,
  SubCategoryDriverOption,
} from '../../../datalabHelper';
import { Stack, Text } from 'braid-design-system';
import {
  BarChartGroup,
  type BarChartItemWithToggleDisplay,
} from '../../BarChart/BarChartGroup';

const barColorList: string[] = ['#5B2084', '#A04BCB', '#1FA575', '#EF672A'];

interface LevelOfImportanceProps {
  categories: DriverSubCategory[];
}
export const LevelOfImportance = ({ categories }: LevelOfImportanceProps) => {
  if (!categories || categories.length === 0) return;

  const getBarColor = (index: number) => {
    if (index > -1 && index < barColorList.length) return barColorList[index];
    return barColorList[0];
  };

  const mapSubCatgegoryDriverOptionResultToBarChartItemToggleDisplay = (
    option: SubCategoryDriverOption,
  ): BarChartItemWithToggleDisplay[] => {
    const totalResults = option.results
      .map((result) => result.value)
      .reduce((a, b) => a + b);
    const x = option.results.map((result, index) => ({
      label: result.name,
      value: Math.round((result.value / totalResults) * 100),
      color: getBarColor(index),
    }));

    return x;
  };

  // ToDo: Add Level of Importance Header
  // ToDo: Add Bar Chart Filter
  return (
    <Stack space="gutter">
      {categories.map((category) => (
        <Stack space="small" key={`TITLE_${category.name}`}>
          <Text size="small" weight="strong">
            {category.name}
          </Text>

          {category.driverOptions.map((option) => (
            <BarChartGroup
              label={option.name}
              tooltip={
                <Text>
                  This is how candidates sort their preferences for the
                  components of Work-life balance. Candidates have the option to
                  choose more than one must-have.
                </Text>
              }
              items={mapSubCatgegoryDriverOptionResultToBarChartItemToggleDisplay(
                option,
              )}
              key={`BARCHART_${option.name}_${category.name}`}
            />
          ))}
        </Stack>
      ))}
    </Stack>
  );
};
